import {
  aCurrentUser,
  aCurrentUserSumo,
  mockAppInfoOperationQuery,
  mockAppInfoOperationSumoQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import {
  allFeatureFlags,
  devFeatureFlags,
  enabledByDefaultFeatureFlags,
} from '@sbu/hooks.featureflag';

const allEnabledFlags = allFeatureFlags.filter(
  (featureFlag) => !devFeatureFlags.includes(featureFlag)
);

export const baseAppInfoOperationQueryResponse = {
  currentUser: aCurrentUser(
    {
      permissions: [
        'can_view_match_lists',
        'can_view_log_mappings',
        'can_delete_rules',
        'can_view_enrichments',
        'cloud_soar_playbooks_configure',
        'can_view_entity_configuration',
        'can_manage_actions',
        'can_manage_entity',
        'can_manage_entity_groups',
        'view_cloud_soar',
        'can_view_insight_statuses',
        'can_view_network_blocks',
        'can_view_file_analysis',
        'cloud_soar_integrations_access',
        'can_view_sumo_integration',
        'can_manage_sumo_integration',
        'can_create_insights',
        'can_manage_file_analysis',
        'can_manage_whitelisted_entities',
        'can_manage_context_actions',
        'can_configure_insight_generation',
        'can_manage_automations',
        'can_manage_network_blocks',
        'can_manage_entity_configuration',
        'can_manage_insight_tags',
        'can_view_rules',
        'can_manage_log_mappings',
        'can_manage_entity_criticality',
        'can_execute_automations',
        'can_view_entity_groups',
        'can_view_automations',
        'can_delete_insights',
        'can_manage_insight_status',
        'can_manage_favorite_fields',
        'can_view_suppress_lists',
        'cloud_soar_integrations_configure',
        'can_manage_custom_entity_type',
        'can_manage_suppress_lists',
        'can_view_threat_intel',
        'can_comment_on_insights',
        'can_view_actions',
        'can_view_custom_insights',
        'can_manage_insight_assignee',
        'can_manage_enrichments',
        'can_view_insight_generation',
        'can_view_tag_schemas',
        'can_manage_threat_intel',
        'cloud_soar_playbooks_access',
        'can_manage_custom_insights',
        'can_view_entity_criticality',
        'can_manage_insight_statuses',
        'can_manage_tag_schemas',
        'can_view_context_actions',
        'can_view_custom_entity_type',
        'can_create_rules',
        'can_edit_rules',
        'can_invoke_actions',
        'can_view_whitelisted_entities',
        'can_manage_match_lists',
        'can_manage_insight_signals',
        'can_manage_automations',
      ],
    },
    new Set<string>(['preferredDateFormat'])
  ),
  isFederatedCluster: false,
  enabledFeatureFlags: [
    ...allEnabledFlags,
    ...enabledByDefaultFeatureFlags.map((ff) => ff.toString()),
  ],
  version: 'e64c761720aeaff4829f49889f1553354cebd17a',
  sumoLogicRegion: null,
  deployment: 'stag',
  orgId: '0000000006ACDE44',
  orgName: 'cse-stag-sandbox',
  cspCustomReportUrl:
    'https://long-endpoint1-events.sumologic.net/receiver/v1/http/ZaVnC4dhaV1FkRnoPAeJYl6jsyRUfabtY-Fyf0uksvsSJ1cSGNxFNTA7uBowyDlULW-YFuRzvD2XFLM9zTVuV0hn5tiqC6gb9H-JrKCJu2Ni5yv1n89jhA==',
  sessionTimeoutMinutes: 360,
};

export const baseAppInfoOperationSumoQueryResponse = {
  currentUserSumo: aCurrentUserSumo({
    id: '410',
    accountType: 'paid',
    accountStatus: 'activated',
    organization: 'sandbox',
    organizationId: 111992388,
    userHashForIntercom:
      '91247B54654046826867FF584F25513511DA887C1E894C58E6A2E76A8FDC989DDA',
    userIdForIntercom: '000000034ed02d-stag',
  }),
};

export const mockAppInfoOperation_federated = mockAppInfoOperationQuery(
  async ({ query: _query, variables: _variables }) => {
    await delay(150);
    return HttpResponse.json({
      data: {
        __typename: 'Query',
        ...baseAppInfoOperationQueryResponse,
        isFederatedCluster: true,
      },
    });
  }
);

export const handlers = [
  mockAppInfoOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: { __typename: 'Query', ...baseAppInfoOperationQueryResponse },
      });
    }
  ),
  mockAppInfoOperationSumoQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          ...baseAppInfoOperationSumoQueryResponse,
        },
      });
    }
  ),
];
